export class Track {
	public name:string;
}
